import { LookupType } from "~/assets/scripts/valueObjects/LookupType"

export default ({ store, app, route }) => ({
	get brand() {
		return store.state.brand
	},
	get isEHIBrand() {
		return !!this.brand && this.brand.code !== "GO"
	},
	get brandClass() {
		return this.isEHIBrand ? `brand-${this.brand.code}` : null
	},
	get brandName() {
		return this.brand?.name ?? "GO Rentals"
	},

	setStorage() {
		if (!this.brand) return app.$sessionStorageService.remove("brand")
		app.$sessionStorageService.set("brand", this.brand)
	},

	set(data) {
		if (!data || data.brand?.code === this.brand?.code) return
		store.dispatch("setBrand", data.brand)
		store.dispatch("toggleHideHeader", this.isEHIBrand)
		this.setStorage(data.brand)
	},

	async setFromQuery(query = {}) {
		let brand = null
		if (query.brand) {
			const brandsResponse = await app.$lookupService.getLookups([LookupType.Brand])
			const brands = brandsResponse.find((item) => item.lookupType === LookupType.Brand)?.lookupOptions.map(brand => brand.payload)
			brand = brands?.find(brand => brand.code === query.brand.toUpperCase()) ?? null
		}
		this.set({ brand })
	},

	restore() {
		const brand = app.$sessionStorageService.get("brand") || null
		this.set({ brand })
	},

	remove() {
		store.dispatch("setBrand", null)
		store.dispatch("toggleHideHeader", false)
		app.$sessionStorageService.remove("brand")
	},
})
